export default __webpack_public_path__ + "e3da636e580bb6d726d5070914ac6d4e.png";